import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import {
  fetchInitialReviewList,
  fetchMyReview,
  fetchReview,
  fetchReviewList,
  initialState,
  MyhouseReviewDetail,
  ReviewParam,
  updateReviewDetail,
  updateReviewList,
  updateReviewSequence,
} from '@Root/slices/myhouse/review'
import MyHouseReviewParam from '@Types/entities/MyHouseReviewParam'

export default function useReview() {
  const dispatch = useDispatch()
  const review = useSelector((state: RootState) => state.review)

  const setReviewSequence = useCallback(
    (sequence: number) => {
      dispatch(updateReviewSequence(sequence))
    },
    [dispatch],
  )

  const loadReview = useCallback(
    (param: ReviewParam) => {
      dispatch(fetchReview(param))
    },
    [dispatch],
  )

  const loadReviewList = useCallback(
    (param: MyHouseReviewParam) => {
      dispatch(fetchReviewList(param))
    },
    [dispatch],
  )
  const loadInitialReviewList = useCallback(
    (param: MyHouseReviewParam) => {
      dispatch(fetchInitialReviewList(param))
    },
    [dispatch],
  )

  const loadMyReview = useCallback(
    (param: ReviewParam) => {
      dispatch(fetchMyReview(param))
    },
    [dispatch],
  )

  /**
   * @param
   */
  const initializeReview = useCallback(
    (detail?: Partial<MyhouseReviewDetail>) => {
      dispatch(
        updateReviewDetail({
          ...initialState.detail,
          ...detail,
        }),
      )
    },
    [dispatch],
  )

  const initializeReviewList = useCallback(() => {
    dispatch(updateReviewList())
  }, [dispatch])

  return {
    review,
    loadReviewList,
    loadInitialReviewList,
    setReviewSequence,
    loadReview,
    loadMyReview,
    initializeReview,
    initializeReviewList,
  }
}
